import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getAllData } from "./Api";

export var allData; // BIG
var changed = 0;
var loading = false;

const initialState = {
  changed: false, // used as a flag when allData changes
  loaded: false,
}

const allDataSlice = createSlice({
  name: "allData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(allDataThunk.fulfilled, (state, action) => {
        if (allData!==action.payload && action.payload!==undefined) {
          changed = new Date().getTime();
          state.changed = changed;
          state.loaded = true;
          allData = action.payload;
        }
      })
    }
});

export const allDataThunk = createAsyncThunk(
  "allData/allData",
  async () => {
    try {
      // don't get alldata too frequently
      const now = new Date().getTime();
      if (loading || changed+5000>now) {
        return;
      }
      loading = true;
      const response = await getAllData();
      loading = false;
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export default allDataSlice.reducer;
